import React, { useEffect, useCallback, useRef } from 'react';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';

import {
  Appointment as AppointmentView,
} from './appointment';
import { useGoBack } from '../../../../hooks/use-go-back';
import { appointmentSettings, AppointmentSettingsProps } from '../../../common/appointment-settings';
import { CancelAppointmentModal } from './cancel-appointment-modal';
import { NoActiveAppointmentModal } from './no-active-appointment-modal';
import { isAppointmentContentShow } from '../../../../utils/appointment/is-appoinment-content-show';
import { InternalLinks } from '../../../../constants';
import { pushStoreCodeIfEnabled } from '../../../../utils';

const AppointmentContainer = ({
  appointments, isLoading, isError,
}: AppointmentSettingsProps): JSX.Element => {
  const { showModal } = useModal();
  const { goBack } = useGoBack();
  const navigate = useNavigate();
  const modalShownRef = useRef(false);

  const onNavigate = useCallback(() => {
    navigate(InternalLinks.home);
  }, [navigate]);

  const handleNavigateToEcp = useCallback(() => {
    navigate(InternalLinks.ecpLocator);
  }, [navigate]);

  const handleNavigateToHome = useCallback(() => {
    navigate(InternalLinks.home);
  }, [navigate]);

  const handleCancelButtonClick = () => {
    const code = appointments?.allAppointmentsByAuthId?.edges?.[0]?.node?.store?.code;
    if (code) {
      pushStoreCodeIfEnabled(code);
    }

    showModal(CancelAppointmentModal, {
      appointmentId: appointments!.allAppointmentsByAuthId.edges[0].node.id,
      onNavigate,
    });
  };

  const handleAppointmentBack = () => {
    goBack();
  };

  useEffect(() => {
    const userAppointment = appointments?.allAppointmentsByAuthId?.edges;
    if (!modalShownRef.current &&
        ((appointments && !userAppointment?.length)
        || (userAppointment?.length && !isAppointmentContentShow(
          userAppointment[0].node.date, userAppointment[0].node.status,
        )))) {
      modalShownRef.current = true;
      showModal(NoActiveAppointmentModal, {
        onNavigateToEcp: handleNavigateToEcp,
        onNavigateToHome: handleNavigateToHome,
      });
    }
  }, [appointments, showModal, handleNavigateToEcp, handleNavigateToHome]);

  return (
    <AppointmentView
      appointments={appointments}
      isLoading={isLoading}
      isError={isError}
      onCancelClick={handleCancelButtonClick}
      onAppointmentClose={handleAppointmentBack}
    />
  );
};

export const Appointment = appointmentSettings(AppointmentContainer);
